import { AppState, EngagementPhase } from "../store/definitions";
import { useDispatch, useSelector } from "react-redux";

import { Box } from "@twilio-paste/core/box";
import { ChatIcon } from "@twilio-paste/icons/esm/ChatIcon";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { WarningIcon } from "@twilio-paste/icons/esm/WarningIcon";
import { changeExpandedStatus } from "../store/actions/genericActions";
import { containerStyles } from "./styles/EntryPoint.styles";

export const EntryPoint = () => {
  const dispatch = useDispatch();
  const { expanded, currentPhase } = useSelector((state: AppState) => ({
    expanded: state.session.expanded,
    currentPhase: state.session.currentPhase,
  }));

  const isError = currentPhase === EngagementPhase.Error;

  return (
    <Box
      as="button"
      data-test="entry-point-button"
      onClick={() => dispatch(changeExpandedStatus({ expanded: !expanded }))}
      {...containerStyles}
      backgroundColor={
        isError ? "colorBackgroundDestructive" : "colorBackgroundPrimary"
      }
      color={isError ? "colorTextInverse" : "colorTextWeakest"}
      _hover={{
        backgroundColor: isError
          ? "colorBackgroundDestructiveStrong"
          : "colorBackgroundPrimaryStronger",
      }}
    >
      {expanded ? (
        <ChevronDownIcon
          decorative={false}
          title="Minimize chat"
          size="sizeIcon80"
        />
      ) : isError ? (
        <WarningIcon decorative={false} title="Chat error" size="sizeIcon60" />
      ) : (
        <ChatIcon decorative={false} title="Open chat" size="sizeIcon60" />
      )}
    </Box>
  );
};
